import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, Observable, Subject, takeUntil } from 'rxjs';
import { appState } from 'src/app';
import { FilterActions } from 'src/app/core/store/filters/actions/filter.actions';
import { selectHelpers } from 'src/app/core/store/helpers/selector/helpers.selectors';
import { LuckyPlayersComponent } from '../../shared/main/lucky-players/lucky-players/lucky-players.component';
import { CarouselBannerComponent } from '../../shared/main/carousel-banner/carousel-banner.component';
import { MoreGamesComponent } from '../../shared/main/more-games/more-games.component';
import { CategoriesComponent } from '../../shared/categories/categories.component';
import { ActiveFiltersComponent } from 'src/app/shared/active-filters/active-filters.component';
import { GamesService } from 'src/app/core/services/gameCatalog/games.service';
import { selectConfig } from 'src/app/core/store/config/selector/config.selectors';
import { selectUserBalances } from 'src/app/core/store/user/selectors/user.selector';
import { LocalStorageService } from 'src/app/core/services/localStorage/local-storage.service';
import { GameLaunchService } from 'src/app/core/services/gameLaunch/game-launch.service';
import { SidebarCategoryLinkComponent } from '../../shared/side-nav/sidebar-category-link/sidebar-category-link.component';
import { MainBannerContainerComponent } from 'src/app/shared/content/main-banner-container/main-banner-container.component';
import { PromotionsComponent } from '../rewards/promotions/promotions.component';
import { VpnMessageComponent } from 'src/app/shared/notifications/notifications/vpn-message/vpn-message.component';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  standalone: true,
  imports: [
    CategoriesComponent,
    MoreGamesComponent,
    CarouselBannerComponent,
    LuckyPlayersComponent,
    PromotionsComponent,
    ActiveFiltersComponent,
    SidebarCategoryLinkComponent,
    MainBannerContainerComponent,
    VpnMessageComponent,
  ],
})
export class MainComponent implements OnInit, OnDestroy {
  helpers$: Observable<any> = this.store.select(selectHelpers);
  config$: Observable<any> = this.store.select(selectConfig);
  unsubus$: Subject<boolean> = new Subject();
  isMobile: boolean = true;
  newGames: any = [];
  hotGames: any = [];
  isConfigLoaded: boolean = false;
  Balance$: Observable<any> = this.store.select(selectUserBalances);
  preLoginGameUrl: string | null = null;
  restrictUser: boolean = false;
  constructor(
    private store: Store<appState>,
    private games: GamesService,
    private storage: LocalStorageService,
    private gameLaunche: GameLaunchService,
    private cdr: ChangeDetectorRef
  ) {}
  ngOnInit() {
    this.config$
      .pipe(
        takeUntil(this.unsubus$),
        filter((res) => res?.isLoaded)
      )
      .subscribe((res) => {
        this.restrictUser = res?.config?.status === 451;
        this.isConfigLoaded = true;
        this.cdr.markForCheck();
      });
    this.store.dispatch(FilterActions['[ClearFilter]ResetFiltersSuccess']());
    this.helpers$.pipe(takeUntil(this.unsubus$)).subscribe((res) => {
      this.isMobile = res.isMobile;
    });

    this.games.getCategoriesIds('new').subscribe((res: any) => {
      this.newGames = res?.gamesByCategory;
    });
    this.games.getCategoriesIds('hot').subscribe((res: any) => {
      this.hotGames = res?.gamesByCategory;
    });
    this.preLoginGameUrl = this.storage.getSessionStorage('preLoginGameUrl');
    if (this.preLoginGameUrl !== null) {
      this.Balance$.pipe(
        takeUntil(this.unsubus$),
        filter((res) => res?.isLoaded)
      ).subscribe((res) => {
        if (this.preLoginGameUrl !== null) {
          this.storage.removeSessionStorage('preLoginGameUrl');
          this.navigateToGameAfterSingIn(this.preLoginGameUrl, res.balance);
        }
      });
    }
  }
  ngOnDestroy(): void {
    this.unsubus$.next(true);
    this.unsubus$.complete();
  }
  navigateToGameAfterSingIn(preLoginGameUrl: string, userBalance: number) {
    if (preLoginGameUrl !== null) {
      const pregameUrl = this.storage.getSessionStorage('preGameUrl');
      if (userBalance == 0 && !pregameUrl?.includes('/games/livecasino')) {
        this.gameLaunche.navigateToGame(preLoginGameUrl.replace(/\/0\//, '/1/'));
      } else {
        this.gameLaunche.checkUserProfile(preLoginGameUrl);
      }
      this.preLoginGameUrl = null;
    }
  }
}
